import { defineComponent as _defineComponent } from 'vue'
import CardContentLoader from '@/components/card-content-loader.vue';
import CardTitle from '@/components/card-title.vue';
import { i18n } from '@/i18n';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { CustomException, windowHelper } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import { CouponInfo } from '@tencent/wphk-components-wecoupon';
import CouponItem from '@tencent/wphk-components-wecoupon/components/coupon-item/index.vue';
import { getCouponListBySPId } from '@tencent/wphk-components-wecoupon/components/mch-coupon-list/business/coupon';
import { isEmpty } from 'lodash-es';
import { computed, onMounted, ref, toRefs } from 'vue';
import { FitIcon } from '@tencent/wphk-ui';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import ShareDialog from '@tencent/wphk-components-wecoupon/components/share-channel/share-dialog.vue';
import { handleCouponShareSetInfo, handleCouponShareShowDialog } from '@tencent/wphk-components-wecoupon/components/share-channel';
import { MerchantType } from '@/types/merchant-info';
import UseGuide from '@tencent/wphk-components-wecoupon/components/guide/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { getBiExt } = useGlobalBi();
const isLoadFinish = ref(false);
const isShowMchCouponList = ref(true);
const { merchantConfig } = toRefs(useMerchantInfo());
const merchantInfo = computed(() => ({
  spId: merchantConfig.value.spId,
  spLogo: merchantConfig.value.mrchLogo,
  spName: merchantConfig.value.mrchName,
}));
const couponList = ref([] as any[]);
const useGuide = ref();
/**
   * 領券結果
   */
const getCouponAction = (result: any) => {
  console.log('getCouponAction', result);
  const { name, data } = result;
  if (name === 'getCoupon' && !data?.err) {
    useGuide.value.playAnimation();
  }
  // this.$emit('showSubscribeDialog', result);
};

/** 券列表分两栏展示 */
const getSortedCouponList = (list: CouponInfo[]) => {
  const resultArr: CouponInfo[][] = [[], []];
  list.forEach((item, index) => {
    const targetIndex = index % 2;
    // we_coupon_get_sp_coupon.cgi返回的属性里没有spid，前端插入处理
    resultArr[targetIndex].push(Object.assign(item, { spId: item.spId || getUrlParamByKey(UrlParamKey.spId) }));
  });
  return resultArr;
};

/** 跳转优惠专区 */
const goCouponHome = (adtag: string) => {
  // 如果是商圈，则跳转到指定分类：
  if (merchantConfig.value.mrchType === MerchantType.mall) {
    const url = `//prom.wechatpay.com.hk/discount-center/coupon_home.shtml?ADTAG=${adtag}#/weCoupons/couponList/shoppingmall`;
    windowHelper.redirect(url);
    return;
  }
  jumpPage.goDiscountCenter({ adtag, delay: 300, isReplace: false });
};

onMounted(async () => {
  if (!merchantInfo.value.spId) {
    isLoadFinish.value = true;
    isShowMchCouponList.value = false;
    return;
  }
  const [err, res] = await to(getCouponListBySPId(merchantInfo.value.spId, merchantInfo.value as any));
  isLoadFinish.value = true;
  if (err) {
    new CustomException(err, 'initWecouponFail', `初始化抢券有so模块失败：${merchantInfo.value.spId}`);
  }
  if (err || isEmpty(res) || !res) {
    // 出错或为空都不展示
    isShowMchCouponList.value = false;
    return;
  }
  couponList.value = getSortedCouponList(res);
});

/**
 * 设置券分享信息
 */
function handleItemClick(item: CouponInfo) {
  const { couponId, couponName } = item;
  const { spId, spLogo, spName } = item.merchantInfo;
  handleCouponShareSetInfo({
    couponName,
    couponId,
    spId,
    spLogo,
    spName,

    adtagPrefix: 'channel',
  });
}
/**
 * 拉起分享弹框（券分享，区别于商户分享）
 */
function handleDetailShareClick(item: CouponInfo) {
  handleCouponShareShowDialog();
}

return { __sfc: true,getBiExt, isLoadFinish, isShowMchCouponList, merchantConfig, merchantInfo, couponList, useGuide, getCouponAction, getSortedCouponList, goCouponHome, handleItemClick, handleDetailShareClick, CardContentLoader, CardTitle, i18n, BaseComponent, CouponItem, FitIcon, ShareDialog, UseGuide }
}

})